<template>
  <div class="w-full mb-8 bg-gray-200 rounded-full h-1.5 mb-4 dark:bg-gray-700">
    <div
      class="bg-primary-600 h-2 rounded-full dark:bg-primary-500 transition-all duration-300"
      :style="{ width: progressPercent + '%' }"
    />
  </div>
</template>

<script>
export default {
  props: {
    step: Number,
    count: Number,
  },

  computed: {
    progressPercent() {
      const percent = ((this.step - 1) / this.count) * 100;

      return percent === 0 ? 2.5 : percent;
    },
  },
};
</script>
